import { all, call, put, takeLatest } from 'redux-saga/effects';
import userActionTypes from 'redux/users/types';
import { userLoginFailure, userLoginSuccess } from 'redux/users/actions';
import request from 'utils/request';
import urls from 'utils/config';
import {
  setLocalAccessToken,
  setLocalRefreshToken,
  setLocalUser,
} from 'utils/helpers';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

export function* userLogIn({ payload: { userCreds, cb } }) {
  const url = `${API_BASE_URL}/ums/login`;

  const response = yield request({
    method: 'post',
    data: userCreds,
    url,
  });
  if (response.success) {
    yield put(
      userLoginSuccess({
        ...response.raw,
        organisation: userCreds.organisation,
      })
    );
    const { accessToken, refreshToken, user } = response.raw;
    setLocalAccessToken(accessToken);
    setLocalRefreshToken(refreshToken);
    setLocalUser(JSON.stringify(user));
    cb(user);
  } else {
    networkErrorHandler(response?.statusCode, 'Invalid Username or Password');
    yield put(userLoginFailure(response.message));
  }
}

function* onSigninStart() {
  yield takeLatest(userActionTypes.USER_LOGIN_START, userLogIn);
}

export function* userSagas() {
  yield all([call(onSigninStart)]);
}
